import { ConfirmMembership } from "./confirmMembership";
import ManageMembersByAddition from "./manageMembers/manageMembersByAddition";
import ManageMembersByEdit from "./manageMembers/manageMembersByEdit";
import { PreviewMembership } from "./previewMembership";
import SelectKeyConditionComponent from "./SelectKeyCondition";
import SelectKeyConditionDefinitionMethod from "./selectMethod";

export class SelectMethod {
  label = "Select method";
  heading = "Add members";
  isConfirmationRequired = false;
  render(_userGroupUniqueName, setCurrentStepState, setDisplayLabels) {
    return (
      <SelectKeyConditionDefinitionMethod
        setCurrentStepState={setCurrentStepState}
        setDisplayLabels={setDisplayLabels}
      />
    );
  }
  static isAdd(action) {
    return action === "add";
  }
}

export class SelectKeyCondition {
  label = "Select conditions";
  heading = null;
  inputFieldsHeading = null;
  confirmationText = null;
  confirmationButtonText = null;
  isConfirmationRequired = true;
  nextStateDisplayLabels = null;

  setDisplayLabels(displayLabels, options) {
    const { isSpecialCondition } = options ?? {};
    this.heading = displayLabels.getHeading(isSpecialCondition);
    this.inputFieldsHeading = displayLabels.getInputFieldHeading();
    this.confirmationText = displayLabels.getConfirmationText(isSpecialCondition);
    this.confirmationButtonText = displayLabels.getConfirmationButtonText();
    this.nextStateDisplayLabels = displayLabels.getNextStateDisplayLabels();
  }

  render(userGroupUniqueName) {
    return (
      <SelectKeyConditionComponent
        userGroupUniqueName={userGroupUniqueName}
        inputFieldsHeading={this.inputFieldsHeading}
      />
    );
  }
  static isAddOrEdit(action) {
    return action === "add" || action === "edit";
  }
}

export class ManageMembersByAdditionStep {
  label = "";
  heading = "";
  isConfirmationRequired = true;
  render(userGroupUniqueName, setCurrentStepState, setDisplayLabels) {
    return (
      <ManageMembersByAddition
        userGroupUniqueName={userGroupUniqueName}
        setCurrentStepState={setCurrentStepState}
        setDisplayLabels={setDisplayLabels}
      />
    );
  }
  setDisplayLabels(displayLabels, options) {
    const { isSpecialCondition } = options ?? {};
    this.heading = displayLabels.getHeading(isSpecialCondition);
    this.confirmationText = displayLabels.getConfirmationText(isSpecialCondition);
    this.confirmationButtonText = displayLabels.getConfirmationButtonText();
    this.nextStateDisplayLabels = displayLabels.getNextStateDisplayLabels();
    this.label = displayLabels.getStepLabel();
  }
  static isAdd(action) {
    return action === "add";
  }
}

export class ManageMembersByEditStep {
  label = "";
  heading = "";
  isConfirmationRequired = true;
  render(userGroupUniqueName, setCurrentStepState, setDisplayLabels) {
    return (
      <ManageMembersByEdit
        userGroupUniqueName={userGroupUniqueName}
        setCurrentStepState={setCurrentStepState}
        setDisplayLabels={setDisplayLabels}
      />
    );
  }
  setDisplayLabels(displayLabels, options) {
    const { isSpecialCondition } = options ?? {};
    this.heading = displayLabels.getHeading(isSpecialCondition);
    this.confirmationText = displayLabels.getConfirmationText(isSpecialCondition);
    this.confirmationButtonText = displayLabels.getConfirmationButtonText();
    this.nextStateDisplayLabels = displayLabels.getNextStateDisplayLabels();
    this.label = displayLabels.getStepLabel();
  }
  static isEdit(action) {
    return action === "edit";
  }
}

export class Preview {
  label = "Preview";
  heading = "Preview condition";
  confirmationText = "";
  confirmationButtonText = "Confirm";
  isConfirmationRequired = true;
  render(userGroupUniqueName) {
    return <PreviewMembership userGroupUniqueName={userGroupUniqueName} />;
  }
  setDisplayLabels(displayLabels, options) {
    const { isSpecialCondition } = options ?? {};
    this.confirmationText = displayLabels.getConfirmationText(isSpecialCondition);
  }
}

export class Confirm {
  label = "Confirm";
  render(userGroupUniqueName) {
    return <ConfirmMembership userGroupUniqueName={userGroupUniqueName} />;
  }
}
